<template>
  <div class="filter-set number-of-rooms">
    <button
      @click.stop="$emit('toggle')"
      :class="{ 'in-use': numberOfRoomsModel.length }"
      class="filter-name"
      type="button"
      :aria-expanded="expanderVisible ? 'true' : 'false'"
      :aria-controls="config.testing.FILTER_ROOMS"
      id="number-of-rooms-toggle"
    >
      <span class="filter-name__label">Huoneluku</span>
      <i class="toggle-expander icon-chevron-down"></i>
    </button>
    <expander :expanded="expanderVisible">
      <div
        :id="config.testing.FILTER_ROOMS"
        class="room-selector"
        role="region"
        aria-labelledby="number-of-rooms-toggle"
      >
        <div class="room" v-for="n in 5" :key="n">
          <button
            type="button"
            class="room-button"
            :class="{ selected: numberOfRoomsModel.includes(n) }"
            @click="toggleNumberOfRooms(n)"
            :aria-pressed="numberOfRoomsModel.includes(n) ? 'true' : 'false'"
            :aria-label="n === 1 ? '1 huone' : `${n} huonetta`"
          >
            {{ n === 5 ? '5+' : n }}
          </button>
        </div>
      </div>
    </expander>
  </div>
</template>

<script setup lang="ts">
import config from '@/config';
import Expander from '../expander/expander.vue';
import searchUtils from '@/app/utils/search-utils';
import { computed } from 'vue';
import useSafeRoute from '@/app/composables/useSafeRoute';
import { useRouter } from 'vue-router';

const props = withDefaults(
  defineProps<{
    expanderVisible?: boolean;
    numberOfRooms?: number[] | number;
  }>(),
  {
    expanderVisible: undefined,
    numberOfRooms: () => [],
  }
);

const router = useRouter();
const route = useSafeRoute();

const numberOfRoomsModel = computed<number[]>({
  get() {
    return Array.isArray(props.numberOfRooms) ? props.numberOfRooms : [props.numberOfRooms];
  },
  set(value: number[]) {
    const updates = { numberOfRooms: value };
    searchUtils.addFilterToUrl(router, route.value, updates);
  },
});

const toggleNumberOfRooms = (n: number): void => {
  numberOfRoomsModel.value = numberOfRoomsModel.value.includes(n)
    ? numberOfRoomsModel.value.filter((v) => v !== n)
    : [...numberOfRoomsModel.value, n];
};
</script>
